import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSuspenseHITLClient } from './useHitlClient'
import { Conversation } from '@botpress/client'
import { getApiClient } from '~/stores/clientsStore'
import { HttpError } from '~/shared'

type Params = {
  workspaceId: string
  botId: string
  onSuccess?: () => void
  onError?: () => void
}

export const useCloseConversation = ({ workspaceId, botId, onSuccess, onError }: Params) => {
  const queryClient = useQueryClient()
  const client = useSuspenseHITLClient({ botId, workspaceId })

  return useMutation({
    mutationFn: async ({ conversationId }: { conversationId: string }) => {
      await client.updateConversation({
        conversationId,
        status: 'solved',
      })

      return conversationId
    },
    onSuccess: async (conversationId) => {
      queryClient.setQueryData<Conversation[]>(
        ['workspaces_', workspaceId, 'bots_', botId, 'conversations', 'hitl', null, null, 'all'],
        (prev) => {
          return prev?.filter((conversation: Conversation) => conversation.id !== conversationId)
        }
      )

      await queryClient.invalidateQueries({
        queryKey: ['workspaces_', workspaceId, 'bots_', botId, 'conversations', 'hitl', null, null, 'all'],
      })

      onSuccess?.()
    },
    onError: () => {
      onError?.()
    },
  })
}
